__turbopack_context__.v({
  "area-line": "chart-module-scss-module__3xvpka__area-line",
  "cont": "chart-module-scss-module__3xvpka__cont",
  "cont-title": "chart-module-scss-module__3xvpka__cont-title",
});
